import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/contextAuth';
import { useProfile } from '../../context/contextProfile';
import { useDesign } from '../../context/contextDesign';
import { useThemeMode } from '../../context/contextTheme';
import SidebarLogo from './logo';
import SidebarItems from './items';
import SidebarDoc from './doc';

import './style.css';

const SideNavbar = () => {
  const { theme } = useThemeMode();
  const { sidebarWidthVal } = useDesign();
  const { sidebarExtended } = useProfile();
  const { upgradePlan } = useAuth();

  const [logoHeight, setLogoHeight] = useState(0);
  const [itemHeight, setItemHeight] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const totalHeight = window.innerHeight; // total sidebar height (viewport)
    const logoRatio = 0.25; // top section ratio
    const itemRatio = 0.75; // bottom section ratio

    const baseLogoHeight = totalHeight * logoRatio;
    const baseItemHeight = totalHeight * itemRatio;

    setLogoHeight(sidebarExtended ? baseLogoHeight : baseLogoHeight * 0.8);
    setItemHeight(sidebarExtended ? baseItemHeight -400 : baseItemHeight - 100);

    // 🔹 Offset adjustment for vertical balance
    // When sidebar collapses, items shift upward to fill the empty space left by the hidden name area.
    setItemOffset(sidebarExtended ? 0 : -100);
  }, [sidebarExtended]);

  return (
    <aside
      className="sidebar d-flex flex-column"
      style={{
        width: sidebarWidthVal,
        background: theme.background2,
        borderRight: `1px solid ${theme.border}`,
        height: 'calc(100vh - 64px)',
        transition: 'all 0.3s ease',
        position: 'relative',
      }}
    >
      {/* 🔹 Fixed Top Section (Logo + Name) */}
      <div
        className="sidebar-logo-wrapper d-flex flex-column align-items-center justify-content-start"
        style={{
          height: logoHeight,
          flexShrink: 0,
          transition: 'height 0.3s ease',
        }}
      >
        <SidebarLogo height={logoHeight * 0.6} width={logoHeight * 0.6} />
      </div>

      {/* 🔹 Scrollable Sidebar Items */}
      <div
        className="flex-grow-1 overflow-y-auto overflow-x-hidden px-1"
        style={{
          height: itemHeight,
          marginTop: sidebarExtended ? '10px' : itemOffset,
          transition: 'all 0.4s ease',
        }}
      >
        <SidebarItems height={itemHeight} />
      </div>
      <SidebarDoc />
    </aside>
  );
};

export default SideNavbar;
